import { render, staticRenderFns } from "./CollaborateUsers.vue?vue&type=template&id=5407428d&"
import script from "./CollaborateUsers.vue?vue&type=script&lang=js&"
export * from "./CollaborateUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports